import React from 'react';

import { useSelector } from 'react-redux';

import FormTitle from 'components/shared/Typography/FormTitle';
import Text from 'components/shared/Typography/Text';
import { privacyPolicyDataSelector, useCustomPrivacyPolicySelector } from 'store/privacyPolicy/selectors';

import styles from '../../index.module.css';
import SafariPrivacyPolicy from '../SafariPrivacyPolicy';

const CustomPrivacyPolicy = () => {
  return (
    <>
      <FormTitle>Terms & Policies</FormTitle>
      <div className={styles.privacyPolicyModalContent}>
        <CustomPrivacyPolicyBody />
      </div>
    </>
  );
};

export default CustomPrivacyPolicy;

export function CustomPrivacyPolicyBody() {
  const useCustomPrivacyPolicy = useSelector(useCustomPrivacyPolicySelector);
  const privacyPolicyData = useSelector(privacyPolicyDataSelector);
  const showCustomPrivacyPolicy = privacyPolicyData && useCustomPrivacyPolicy;

  if (showCustomPrivacyPolicy) {
    return (
      <Text accent style={{ '--font_family-base': 'var(--font_family-accent)' }}>
        <div className="lexical" dangerouslySetInnerHTML={{ __html: privacyPolicyData }} />
      </Text>
    );
  }

  return <SafariPrivacyPolicy />;
}
